import { IconProps } from ".";
import Icon from "./assets/chant_message_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24ChatMessageV2(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
